module.exports = __webpack_public_path__ + "img/A高通锐化1000.8bbbdbcb.png";